import axios from "axios";

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

// Backup Bearer auth (in case cookies get blocked cross-site)
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("session_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const AUTH_REDIRECT_BASE = "https://auth.emergentagent.com";
export const API_ORIGIN = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + "/auth/callback";
  window.location.href = `${AUTH_REDIRECT_BASE}/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export default api;
